const appConfigs = {
    // =================================
    // Konfiguracja dla ePsycholog
    // =================================
    EPSYCHOLOG: {
        appName: "ePsycholog",
        appSubtitle: "Twój kompas w świecie emocji",
        theme: 'professional',
        features: {
            AI_CHAT: true,
            JOURNAL: true,
            EXERCISES: true,
            KNOWLEDGE_BASE: true,
            PSYCHOLOGIST_LIST: true,
            APPOINTMENTS: true,
            TESTS: true,
        },
        auth: {
            ENABLE_OAUTH_GOOGLE: true,
            ENABLE_OAUTH_FACEBOOK: true,
            ENABLE_CODE_LOGIN: false,
            ENABLE_STANDARD_REGISTER: true,
        },
    },
    // =================================
    // Konfiguracja dla Tarczy Ucznia
    // =================================
    ANTIBULLYING: {
        appName: "Tarcza Ucznia",
        appSubtitle: "Twoje bezpieczne miejsce",
        theme: 'childFriendly',
        features: {
            AI_CHAT: false, // Zostawiamy jako "Czat Zgłoszeniowy"
            JOURNAL: true,
            EXERCISES: true,
            KNOWLEDGE_BASE: true,
            PSYCHOLOGIST_LIST: false,
            APPOINTMENTS: false,
            TESTS: false,
        },
        auth: {
            ENABLE_OAUTH_GOOGLE: false,
            ENABLE_OAUTH_FACEBOOK: false,
            ENABLE_CODE_LOGIN: true,
            ENABLE_STANDARD_REGISTER: false, // Rejestracja tylko przez kody od szkoły
        },
    }
};

const configSet = process.env.REACT_APP_CONFIG_SET || 'EPSYCHOLOG';
export const AppConfig = appConfigs[configSet];